<template>
  <div class="style-tab-button-text">
    <ul class="editor-design">
      <li>
        テキスト
      </li>
      <li class="flex-box end">
        <!-- フォント -->
        <select-box
          :target="'font-family-name'"
          :value="value['font-family-name']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 書体 -->
        <select-style
          :fontWeight="value['font-weight']"
          :fontStyle="value['font-style']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 文字の間隔 -->
        <select-box
          :target="'letter-spacing'"
          :value="value['letter-spacing']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <li class="flex-box">
        <!-- フォントサイズ -->
        <select-box
          :target="'font-size'"
          :value="value['font-size']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 文字色 -->
        <select-color
          :type="'part'"
          :target="'color'"
          :selector="null"
          :value="value['color']"
          @updateStyles="updateStyles($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectStyle from '@/components/Content/Palette/CommonLayouts/EditStyleWeightAndItalic'

export default {
  props: [
    'value',
    'sectionId',
    'partsContainerId',
    'partId',
  ],
  components: {
    SelectBox,
    SelectColor,
    SelectStyle,
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updatePartStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        styles: styles
      })
    },
  }
}
</script>

<style lang="scss">
.style-tab-button-text {
  .editor-design {
    .flex-box {
      &.end {
        align-items: flex-end;
      }
    }
  }
}
</style>
